import React, { useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import Input from '@mui/material/Input';

import FormControl from '@mui/material/FormControl';
import { useObjectStore } from "../zustand/objects";
import { Button, ActionIcon, Tooltip } from '@mantine/core';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

const ObjectTitleName = ({open, title, id, isLocked, borderColour}) => {

  const [editing, setEditing] = useState(false)
  const { arrangeUndoRedo, updateObjectTitle, currentObjectArtboard, updateObjectTitleStatus, editingObjectTitle } = useObjectStore();

  const handleClick = () => {
    updateObjectTitleStatus(true)
    // setEditing(true)
  }

  const handleSubmit = (val) => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "objectTitle"
      })
      // send update to zustand
    updateObjectTitle(id, currentObjectArtboard, val, false)
    // setEditing(false)
    updateObjectTitleStatus(false)
    console.log(editingObjectTitle)

  }

  
  

  return (
    
      <>
 
      {editingObjectTitle ?
        <FormControl onBlur={(e) => handleSubmit(e.target.value)} style={{width:'100px'}}>
          <Input id="outlined-basic" defaultValue={title} autoFocus variant="outlined" onKeyPress={(e) => { if (e.key === 'Enter') { handleSubmit(e.target.value) } }} />
        </FormControl>
        :
        <Tooltip title="Edit object name">
          <ActionIcon onClick={() => !isLocked && handleClick()} size={'md'} variant="outline" aria-label="Settings" color={borderColour}>
            <EditNoteOutlinedIcon style={{ width: '70%', height: '70%' }} stroke={1.5} />
          </ActionIcon></Tooltip>}  
        </>
 
  );
};


export default ObjectTitleName;
